export default __webpack_public_path__ + "static/media/blood-type.a0abf4b6.svg";